import { createContext, ReactNode, use, useState } from 'react';

export const DataContext = createContext({
    filters: null,
    setFilters: null,
    data: null,
    isLoading: false,
});

export function useDataContext() {
    const context = use(DataContext);
    return context;
}

export function useData() {
    const { data } = useDataContext();
    return data;
}

export function useDataIsLoading() {
    const { isLoading } = useDataContext();
    return isLoading;
}

interface DataContextProviderProps<Data = unknown> {
    data: Data;
    isLoading?: boolean;
    children: ReactNode;
}

export function DataContextProvider<Data>({
    data = null,
    isLoading = false,
    children,
}: DataContextProviderProps<Data>) {
    const [filters, setFilters] = useState(null);
    const value = {
        data,
        isLoading,
        filters,
        setFilters,
        clearFilters: () => setFilters(null),
    };

    return <DataContext value={value}>{children}</DataContext>;
}
